resolveObject